import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import SuspenseContent from './containers/SuspenseContent';
import { atom } from "jotai/index";
import DataLoading from "./DataLoading.tsx";
import 'sweetalert2/src/sweetalert2.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

export const authuserAtom = atom(null);

root.render(
  <React.StrictMode>
    <DataLoading>
    <Suspense fallback={<SuspenseContent />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
    </DataLoading>
  </React.StrictMode>
);

